// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__21GHv","name":"Header_name__3ZyW6","birthday":"Header_birthday__1kxo1","skeleton":"Header_skeleton__22rmm"};